import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <Header sidebarCollapsed={collapsed} />
      <main className={`transition-all duration-300 pt-[72px]  min-h-screen ${collapsed ? 'ml-16' : 'ml-60'}`}>
        <div className="p-6 animate-fade-in">
          {children}
        </div>
        {/* <footer className={`fixed bottom-0 right-0 py-3 bg-white/80 backdrop-blur-md border-t border-slate-200 text-center text-[11px] text-slate-500 z-20 transition-all duration-300 ${collapsed ? 'left-16' : 'left-60'}`}>
          Designed and developed by Pinkmoon Technologies Pvt Ltd
        </footer> */}
      </main>
    </div>
  );
};
